export default __webpack_public_path__ + "static/media/mc-t-card.74a2ce7d.png";